module.exports = __webpack_public_path__ + "static/media/vital.ecd3f179.svg";